import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  setUnitListAction,
  setUnitDetailsAction,
  setUnitFilterAction,
} from '../../../stores/actionTypes/manufactureUnitActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchUnitList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listUnit', payload)
      .then((response) => {
        dispatch(setUnitListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setUnitListAction([]));
        showAlert('Failed get List UnitList', 'warning');
      });
    return data;
  };

  const createUnit = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/createUnit', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Unit created successfully', 'success');
          navigate('/manufacture/production');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    // return data;
  };

  const handleDeleteUnit = async (payload) => {
    await axiosInstance
      .post('/deleteUnit', payload)
      .then(() => {
        showAlert('Unit deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  Unit', 'warning');
      });
  };

  const fetchGetUnitDetails = async (payload) => {
    await axiosInstance
      .post('/getUnit', payload)
      .then((response) => {
        dispatch(setUnitDetailsAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setUnitDetailsAction({}));
        showAlert('Failed get Unit Details', 'warning');
      });
  };

  const editUnit = async (payload) => {
    await axiosInstance
      .post('/updateUnit', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Unit updated successfully', 'success');
          navigate('/manufacture/production');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const fetchGetUnitFilter = async () => {
    await axiosInstance
      .get('/unitFilters')
      .then((response) => {
        dispatch(setUnitFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setUnitFilterAction([]));
        showAlert('Failed get  Unit Filter', 'warning');
      });
  };
  return {
    fetchUnitList,
    createUnit,
    handleDeleteUnit,
    fetchGetUnitDetails,
    editUnit,
    fetchGetUnitFilter,
  };
}
